"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PhoneCodeForm = PhoneCodeForm;
Object.defineProperty(exports, "VerifyCodeBtn", {
  enumerable: true,
  get: function () {
    return _VerifyCodeBtn.default;
  }
});
Object.defineProperty(exports, "VoiceCode", {
  enumerable: true,
  get: function () {
    return _VoiceCode.default;
  }
});
Object.defineProperty(exports, "EduVerifyCode", {
  enumerable: true,
  get: function () {
    return _EduVerifyCode.default;
  }
});
Object.defineProperty(exports, "CountDown", {
  enumerable: true,
  get: function () {
    return _CountDown.default;
  }
});

var _react = _interopRequireDefault(require("react"));

var _PhoneCodeForm = _interopRequireDefault(require("./components/PhoneCodeForm"));

var _VerifyCodeBtn = _interopRequireDefault(require("./components/VerifyCodeBtn"));

var _VoiceCode = _interopRequireDefault(require("./components/VoiceCode"));

var _EduVerifyCode = _interopRequireDefault(require("./utils/EduVerifyCode"));

var _CountDown = _interopRequireDefault(require("./utils/CountDown"));

function getVerifyCodeIns(appId) {
  return new _EduVerifyCode.default({
    appId
  });
}

function PhoneCodeForm(props) {
  if (!props.getCode) {
    const EduVerifyCodeIns = getVerifyCodeIns(props.appId);
    props.getCode = EduVerifyCodeIns.getCode;
  }

  return /*#__PURE__*/_react.default.createElement(_PhoneCodeForm.default, props);
}